import classNames from "classnames";

type Props = {
  count?: number;
  className?: string;
  unstyled?: boolean;
};

export default function UnreadBadge({ count, className }: Props) {
  if (!count || count === 0) return null;

  return (
    <span
      className={classNames(
        "badge rounded-xl bg-unread text-[10px] ml-1", // ml-1 (margin-left) to have a margin to an potenrial favorite star icon as well as the name of a userbar menu item
        {
          "px-1": count >= 10,
        },
        className,
      )}
    >
      {count > 99 ? "99+" : count}
    </span>
  );
}
